function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 10.75a5 5 0 11-10 0 5 5 0 0110 0zm0 0v-4m0 4v1.945c0 1.055.5 2.555 2 2.555 2 0 3-2.299 3-4.5 0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10a9.958 9.958 0 004.444-1.04",
  fill: "none",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAt = function SvgAt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    stroke: "#9193A9"
  }, props), _ref);
};

export default SvgAt;